import type { PoolPurpose } from "@/lib/types";

export function poolPurposeLabel(purpose: PoolPurpose): string {
  return purpose === "ci" ? "CI testing" : "R&D";
}
